/**
 * Map an FO metric condition onto the shared editor's condition shape.
 *
 * This is an explicit allow-list: a field omitted here is dropped silently, with
 * no type error, the moment the user touches the condition. Kept in its own leaf
 * module (type-only imports) so the contract can be tested without dragging in
 * the rule-page barrels, which import each other.
 *
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FlowTagCondition } from '@trafficpulse/shared';
import type { TagRuleCondition } from '@/hooks';

export type FlowTagMetricCondition = Extract<FlowTagCondition, { kind: 'metric' }>;

export function toMetricCondition(condition: FlowTagMetricCondition): TagRuleCondition {
  return {
    field: condition.field,
    operator: condition.operator,
    value: condition.value,
    countryThresholds: condition.countryThresholds,
    campaignThresholds: condition.campaignThresholds,
  };
}
